import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

// Backend resource path is @Path("web/workshop/equipment/..."), mounted under servlet /web/*
const BASE_URL = BEPI_API.workshop;

export const WorkshopEquipmentApi = {
  getEquipmentDetails: (id) => axios.get(`${BASE_URL}/equipment/${id}`),
  getEquipmentPhotos: (id) => axios.get(`${BASE_URL}/equipment/${id}/photos`),
  getEquipmentReports: (id) => axios.get(`${BASE_URL}/equipment/${id}/reports`),
  downloadReport: (fileName) => axios.get(`${BASE_URL}/equipment/reports/${fileName}`, {
    responseType: 'blob'
  }),
  getServices: () => Promise.reject(
    // TODO: INEXISTENTE no backend: /web/workshop/services
    new Error('Endpoint de catalogo de servicos indisponivel no backend atual.')
  ),
  uploadPhoto: (id, photoData) => axios.post(`${BASE_URL}/equipment/${id}/photos`, photoData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deletePhoto: (id, photoId) => axios.delete(`${BASE_URL}/equipment/${id}/photos/${photoId}`),
  uploadReport: (id, reportData) => axios.post(`${BASE_URL}/equipment/${id}/reports`, reportData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteReport: (id, reportId) => axios.delete(`${BASE_URL}/equipment/${id}/reports/${reportId}`)
};
